// @ts-nocheck
import {
    TRANSACTIONS_DATA_CHANGED,
    ACCOUNTING_PERIOD_DATA_CHANGED,
    TRANSACTIONS_DATA_CLEARED,
    ACCOUNTING_PERIOD_DATA_CLEARED,
} from '../types';

const initialState = {
    transactionsData: [],
    accountingPeriodsRecord: {
        logs: [],
        summary: {},
    },
};

const transactions = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case TRANSACTIONS_DATA_CHANGED: {
            return {
                ...state,
                transactionsData: payload,
            };
        }
        case TRANSACTIONS_DATA_CLEARED: {
            return {
                ...state,
                transactionsData: initialState.transactionsData,
            };
        }
        case ACCOUNTING_PERIOD_DATA_CHANGED: {
            return {
                ...state,
                accountingPeriodsRecord: {
                    ...state.accountingPeriodsRecord,
                    ...payload,
                },
            };
        }
        case ACCOUNTING_PERIOD_DATA_CLEARED: {
            return {
                ...state,
                accountingPeriodsRecord: initialState.accountingPeriodsRecord,
            };
        }
        default:
            return state;
    }
};

export default transactions;
